import React from "react";

const NotFound = () => {
  return <div>Not Found page</div>;
};

export default NotFound;
